<template>
  <div class="game flex_a_c">
    <div
      class="game_icon bg_contain"
      :class="{ default_game_icon: !icon }"
      :style="{
        backgroundImage: `url(${icon || 'https://image.hzwxbz2.cn/wxbox/2023/pic/jyy_1690178817036_4b3ec2d4e3099d3fa684a40744e9c8d9.png'})`
      }"
    >
    </div>
    <div class="game_ctx flex_1 ml_6">
      <div class="game_name fs_14 bold">{{ gameName }}</div>
      <div class="game_desc fs_12 flex_a_c color_grey mt_4 scale08">
        <div class="game_folkers van-hairline--right pr_4 mr_4">{{ initPlay }}人在玩</div>
        <div class="game_divider"></div>
        <div class="game_score">评分{{ Number(score).toFixed(1) }}</div>
      </div>
      <div class="game_tags fs_12 flex_a_c scale08_bot">
        <div
          class="game_tag"
          v-for="(tag, idx) in tagList"
          :key="idx"
          :style="{
            backgroundColor: tag.color,
            color: contrastTextColor(tag.color)
          }"
        >{{ tag.tag }}</div>
      </div>
    </div>
    <button
      class="game_btn"
      @click="$emit('go')"
    >
      {{ btnText }}
    </button>
  </div>
</template>

<script>
import { contrastTextColor } from '@/utils'
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    gameName: {
      type: String,
      default: '**礼包'
    },
    initPlay: {
      type: [Number, String],
      default: 1886
    },
    score: {
      type: [Number, String],
      default: 9.1
    },
    gameUrl: {
      type: String,
      default: ''
    },
    tagList: {
      type: Array,
      default: () => []
    },
    btnText: {
      type: String,
      default: '一键开玩'
    },
  },
  data () {
    return {
      contrastTextColor,
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.game_icon {
  width: 58px;
  height: 58px;
  border-radius: 6px;
}

.game_ctx {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  min-width: 0; // 神秘魔法，这一行不能删
}

.game_btn {
  font-size: 14px;
  min-width: 70px;
  box-sizing: border-box;
  height: fit-content;
  padding: 8px 16px;
  line-height: 1;
  background-color: #FFA614;
  color: #FFFFFF;
  border-radius: 1000px;
  border: none;
}


.game_folkers {
  border-right: 1px solid #999;
}
.game_divider {
  width: 1px;
  height: 100%;
  background-color: #999;
  border-right: 1px solid #999;
}

.game_tags {
  width: 125%;
  .game_tag {
    color: #ccc;
    padding: 4px 6px;
    background-color: #fff3ef;
    border-radius: 4px;
  }
  .game_tag + .game_tag {
    margin-left: 4px;
  }
}

</style>